
<!--
  キャラ詳細
-->


<template>
    <div class="chara-detail">

        <transition name="chara-loading">
            <div class="chara-loading p-loading" v-show="is_loading"></div>
        </transition>

        <transition name="chara-detail__image">
            <div class="chara-detail__image" v-show="!is_change_image">
                <img :src="image" class="u-sz-w100-sp">
            </div>
        </transition>

        <transition name="chara-detail__text">
            <div class="chara-detail__text" v-show="!is_loading">
                <!-- <div class="chara-detail__name"><img :src="chara.name_img" :alt="chara.name"></div> -->
                <div class="chara-detail__name" v-html="chara.name"></div>
                <h3 class="chara-detail__name-en" v-html="chara.name_en"></h3>
                <div class="chara-detail__cv">
                    <span class="chara-detail__cv-mark">CV</span> {{chara.cv_en}}
                    <span class="chara-detail__cv-ja">{{chara.cv}}</span>
                </div>
                <div class="chara-detail__note" v-html="chara.note"></div>

                <ul class="c-tabmenu chara-detail__tab">
                    <li class="c-tabmenu__item" v-for="(image, index) in chara.images" :key="index">
                        <a class="c-tabmenu__link" @click.prevent:="change_image(index)" :class="{'router-link-active':image_idx === index}">
                            <span class="c-tabmenu__text">{{image.text}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>


<script>
// プリロードクラス
import preload from '../../js/caracol_es2015.1.0/util/preload';
// キャラ用データ
import chara_data from '../../js/page/chara/chara_data';


export default {
    data() {
        return {
            chara: {},
            is_loading: true,
            is_change_image: true,
            // 表示する画像
            image_idx: 0
        };
    },
    computed: {
        image() {
            if (!this.chara.images) {
                return null;
            }
            return this.chara.images[this.image_idx].image;

        }
    },
    watch: {
        // ルーター変更されたらキャラ変更する
        $route: 'change_chara'
    },
    created() {
        this.change_chara();
    },
    methods: {
        /**
         * 絵を変更する
         */
        change_image(idx) {
            this.is_change_image = true;
            setTimeout(() => {
                this.image_idx = idx;
                this.is_change_image = false;
            }, 400);
        },
        /**
        * Vue-router からキャラが変更された
        * この関数は全ての chara-line が受け取る
        */
        change_chara() {
            // 読み込み開始
            this.is_loading = true;
            // 立ち絵変更開始
            this.is_change_image = true;

            // キャラIDが無指定（物語だけ変更）の場合は無視する
            // この後 chara-content.vue 内でキャラIDが確定するので、それを待つ
            if (!this.$route.params.id) {
                return;
            }

            // URLパラメータで指定されたデータを取得
            const id = this.$route.params.id;
            const story = this.$route.params.story;
            // プリロード
            this.load_images(story, id);

        },
        /**
        * 画像をプリロードする
        */
        load_images(story, id) {
            const chara = chara_data.get_chara(story, id);
            const urls = [];

            chara.images.forEach((v, i, a) => {
                urls.push(v.image);
            });

            preload(urls)
                .done(() => {
                    setTimeout(() => {
                        this.is_loading = false;
                        this.is_change_image = false;
                        this.chara = chara;
                        this.image_idx = 0;
                    }, 400);
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// chara-detail.vue?f59f9a26